import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { SideNavItem } from './side-nav.types';
import { items } from './side.nav-utils';
import { CheckPermissionsDirective } from '@app/core/permissions/permission.directive';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    FlexLayoutModule,
    RouterModule,
    CheckPermissionsDirective,
  ],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent {
  public pages: SideNavItem[];
  constructor(private router: Router) {
    this.pages = items;
  }

  isActive(link: string): boolean {
    const pageLink = link.startsWith('/') ? link : `/${link}`;
    const currentUrl = this.router.url;

    if (pageLink === '/') {
      return currentUrl === '/';
    }

    return currentUrl.startsWith(pageLink);
  }
}
